import { useTranslation } from "react-i18next";
import { format } from "date-fns";

import { useWorkspaceSettingsStore } from "../../store/useWorkspaceSettingsStore";

import { EditableWorkspaceName } from "./EditableWorkspaceName";
import { EditableWorkspaceLogo } from "./EditableWorkspaceLogo";

import { currentLanguageLocale } from "@/i18n/getDateFnsLocale.ts";

export const WorkspaceInfoCard = () => {
  const { t } = useTranslation(["workspaces", "common"]);
  const { settings } = useWorkspaceSettingsStore();

  if (!settings) return null;

  const workspace = settings.workspace;
  const createdDate = format(new Date(workspace.created_at), "PPP", {
    locale: currentLanguageLocale(),
  });

  return (
    <div className="bg-foreground/50 relative overflow-hidden rounded-xl border-none p-4 shadow-lg backdrop-blur-xl">
      {/* Background Pattern - Gradient Circles */}
      <div className="absolute inset-0 overflow-hidden rounded-xl opacity-5">
        <div className="absolute -top-20 -right-24 h-48 w-48 rounded-full bg-gradient-to-br from-blue-600 to-green-500" />
        <div className="absolute -bottom-24 -left-20 h-56 w-56 rounded-full bg-gradient-to-tr from-purple-600 to-pink-500" />
      </div>

      <div className="relative">
        {/* Centered Content */}
        <div className="flex flex-col items-center text-center">
          {/* Editable Workspace Logo */}
          <div className="mb-3">
            <EditableWorkspaceLogo logoUrl={workspace.picture} workspaceName={workspace.name} />
          </div>

          {/* Editable Workspace Name */}
          <div className="mb-1">
            <EditableWorkspaceName
              className="justify-center"
              workspaceName={workspace.name}
              workspaceType={workspace.workspace_type}
            />
          </div>

          {/* Description */}
          <p className="text-muted-foreground text-xs md:text-sm">
            {t("workspaces:settings.workspaceInfo.description", {
              defaultValue: "Workspace created on {{date}}",
              date: createdDate,
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
